"use client";

import React, { type HTMLAttributes, type ReactElement } from "react";
import {
  ObservatoryStatSite,
  ObservatoryStatTimeserie,
  ObservatoryStat,
} from "@/components";
import type { Observatory } from "@/types";
import { Calendar, MapPinned } from "lucide-react";

interface ObservatoryStatListProps extends HTMLAttributes<HTMLDivElement> {
  observatory: Observatory;
}

function ObservatoryStatList({
  observatory,
}: Readonly<ObservatoryStatListProps>): ReactElement | null {
  if (
    observatory.stat?.site ||
    observatory.stat?.timeserie ||
    observatory.stat?.doi
  ) {
    return (
      <section className="p-4">
        <ul className="list-none flex flex-row gap-4 h-40">
          {observatory.startYear ? (
            <li className="flex-1">
              <ObservatoryStat
                number={observatory.startYear}
                label="Année de démarrage"
                icon={<Calendar strokeWidth={1} />}
              />
            </li>
          ) : null}
          {observatory.stat.doi ? (
            <li className="flex-1">
              <ObservatoryStat
                number={observatory.stat.doi}
                label="DOI"
                icon={<MapPinned strokeWidth={1} />}
              />
            </li>
          ) : null}
          {observatory.stat.site ? (
            <li className="flex-1">
              <ObservatoryStatSite observatory={observatory} />
            </li>
          ) : null}
          {observatory.stat.timeserie ? (
            <li className="flex-1">
              <ObservatoryStatTimeserie observatory={observatory} />
            </li>
          ) : null}
        </ul>
      </section>
    );
  }

  return null;
}

export { ObservatoryStatList, type ObservatoryStatListProps };
